<template>
  <div class="the-navbar__user-meta flex items-center hatch-popup">
    <div class="text-right leading-tight hidden sm:block">
      <p class="font-semibold">{{ displayName }}</p>
      <small>Actief</small>
    </div>

    <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
      <div class="con-img ml-3">
        <img
                key="onlineImg"
                :src="avatar"
                alt="user-img"
                width="40"
                height="40"
                class="rounded-full shadow-md cursor-pointer block bg-primary"
        />
      </div>

      <vs-dropdown-menu class="vx-navbar-dropdown">
        <ul style="min-width: 9rem">
          <li v-if="isStaff()"
                  class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
                  @click="darkMode"
          >
            <feather-icon icon="MoonIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Dark mode</span>
          </li>
          <li v-if="isStaff()"
                  class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
                  @click="settings"
          >
            <feather-icon icon="SettingsIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Instellingen</span>
          </li>
          <li v-if="isStaff()"
                  class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
                  @click="openHatch"
          >
            <feather-icon icon="CastIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Luik openen</span>
          </li>
          <li v-if="isStaff()"
              class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
              @click="openRegistrationPopup"
          >
            <feather-icon icon="DollarSignIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">In/uitklokken</span>
          </li>

          <li
              class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
          >
            <feather-icon icon="SettingsIcon" svgClasses="w-4 h-4" />
            <span class="ml-2"><a href="https://info.hebtrek.nl/algemene-voorwaarden/" target="_blank">Algemene voorwaarden</a></span>
          </li>
          <li
                  class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
                  @click="logout"
          >
            <feather-icon icon="LogOutIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Uitloggen</span>
          </li>
        </ul>
      </vs-dropdown-menu>
    </vs-dropdown>
    <vs-popup :active.sync="hatchPopup" :title="hatchPopupTitle" class="hatch-popup" v-if="deliverer !== null">
          <div class="wrapper">
            <vs-avatar size="100px" :src="deliverer.image"/>
            <p>{{ deliverer.firstname }} wilt het luik open in {{ deliverer.area }}</p>
          </div>
        <div class="vx-col w-full request-button-row" style="text-align: right">
          <vs-button
                  class="mr-3 mb-2 vs-con-loading__container"
                  style="text-align: right"
                  @click="denyHathcRequest"
                  type="flat"
          >Verzoek afwijzen
          </vs-button>
          <vs-button
                  class="mr-3 mb-2 vs-con-loading__container"
                  @click="approveHatchOpen()"
                  style="text-align: right"

          >Luik open
          </vs-button>
        </div>
    </vs-popup>
    <vs-popup :active.sync="batteryPopup" :title="batteryChangeTitle" v-if="deliverer !== null">
      <div class="vx-row">
        <div class="vx-col w-full" style="text-align: center">
          <vs-button
                  class="mr-3 mb-2 vs-con-loading__container"
                  @click="approveBatteryRequest()"
                  style="text-align: right"
          >Accu wisselen
          </vs-button>

          <vs-button
                  class="mr-3 mb-2 vs-con-loading__container"
                  style="text-align: right"
                  @click="denyBatteryRequest()"
          >Niet toestaan
          </vs-button>
        </div>
      </div>
    </vs-popup>
    <ht-manual-hatch></ht-manual-hatch>
    <ht-registration-popup></ht-registration-popup>
  </div>
</template>

<script>

  import HatchPopup from '../../../../views/pages/Dashboard/popups/OpenHatch';
  import RegistrationPopup from '../../../../views/pages/Staff/RegistrationPopup';

  export default {
    components: {
      "ht-manual-hatch": HatchPopup,
      "ht-registration-popup": RegistrationPopup
    },
    data() {
      return {
        name: "",
        hatchPopup: false,
        batteryPopup: false,
        deliverer: null,
      };
    },
    computed: {
      hatchPopupTitle() {
        if (this.deliverer !== null) {
          return "Luik voor " + this.deliverer.firstname + " openen?";
        }
      },
      batteryChangeTitle() {
        if (this.deliverer !== null) {
          return "Mag " + this.deliverer.firstname + " zijn accu wisselen?";
        }
      },
      displayName() {
        let user = JSON.parse(localStorage.getItem("user"));
        if (user["insertion"] !== null) {
          return (
                  user["firstname"] + " " + user["insertion"] + " " + user["lastname"]
          );
        } else {
          return user["firstname"] + " " + user["lastname"];
        }
      },
      avatar() {
        return "/img/hebtrek.png";
      },
    },
    methods: {

      isStaff() {
        console.log(localStorage.getItem("stafftoken") !== null)
        return localStorage.getItem("stafftoken") !== null;
      },
      logout() {
        // Delete data
        localStorage.clear();
        this.$router.push("/login").catch(() => {});
      },

      openRegistrationPopup() {
        this.$events.fire('open-registration-model');
      },

      settings() {
        this.$router.push("/user/settings").catch((e) => {
          console.log(e);
        });
      },
      approveBatteryRequest() {
        let deliverer = this.deliverer;
        let data = new FormData();
        data.append("delivererId", deliverer._id);
        this.$http
                .post("https://staffapi.staging.hebtrek.nl/v1/battery/approve", data, {
                  headers: {
                    Authorization:
                            "Bearer " + JSON.parse(localStorage.getItem("stafftoken")),
                    "Content-Type": "multipart/form-data",
                  },
                })
                .then((response) => {
                  this.$vs.notify({
                    title: "Success",
                    text: deliverer.firstname + " is ingelicht en zal naar kantoor komen",
                    color: "success",
                  });
                  this.batteryPopup = false;
                  this.deliverer = null;
                })
                .catch((error) => {
                  this.$util.logError(error, this.$vs);
                });
      },

      denyBatteryRequest() {
        let deliverer = this.deliverer;
        let data = new FormData();
        data.append("delivererId", deliverer._id);
        this.$http
                .post("https://staffapi.staging.hebtrek.nl/v1/battery/deny", data, {
                  headers: {
                    Authorization:
                            "Bearer " + JSON.parse(localStorage.getItem("stafftoken")),
                    "Content-Type": "multipart/form-data",
                  },
                })
                .then((response) => {
                  this.$vs.notify({
                    title: "Success",
                    text: deliverer.firstname + " is ingelicht en zal even moeten wachten",
                    color: "success",
                  });
                  this.batteryPopup = false;
                  this.deliverer = null;
                })
                .catch((error) => {
                  this.$util.logError(error, this.$vs);
                });
      },


      openHatch() {
        this.$events.fire('open-manual-hatch-popup');
      },

      approveHatchOpen() {
        let deliverer = this.deliverer;
        let data = new FormData();
        data.append("delivererId", deliverer._id);
        this.$http
                .post("https://staffapi.staging.hebtrek.nl/v1/hatch/open", data, {
                  headers: {
                    Authorization:
                            "Bearer " + JSON.parse(localStorage.getItem("stafftoken")),
                    "Content-Type": "multipart/form-data",
                  },
                })
                .then((response) => {
                  this.$vs.notify({
                    title: "Success",
                    text: "Luik in " + deliverer.area + " gaat nu open",
                    color: "success",
                  });
                  console.log(this.deliverer);
                })
                .catch((error) => {
                  this.$util.logError(error, this.$vs);
                });
      },

      denyHathcRequest() {
        let deliverer = this.deliverer;
        let data = new FormData();
        data.append("delivererId", deliverer._id);
        this.$http
                .post("https://staffapi.staging.hebtrek.nl/v1/hatch/decline", data, {
                  headers: {
                    Authorization:
                            "Bearer " + JSON.parse(localStorage.getItem("stafftoken")),
                    "Content-Type": "multipart/form-data",
                  },
                })
                .then((response) => {
                  this.$vs.notify({
                    title: "Gelukt",
                    text: "Verzoek voor " + deliverer.firstname + " is afgewezen",
                    color: "success",
                  });
                  this.hatchPopup = false;
                })
                .catch((error) => {
                  this.$util.logError(error, this.$vs);
                });
      },

      darkMode() {
        this.$store.dispatch("updateTheme", "dark");
      },
    },

    mounted() {
      this.$events.listen("open-hatch-request", (deliverer) => {
        this.hatchPopup = true;
        this.deliverer = deliverer;
        console.log(deliverer);iuo7
      });

      this.$events.listen("staff-hatch-decision", (data) => {
        let received = JSON.parse(data);
        if (this.deliverer !== null) {
          if(received.deliverer._id === this.deliverer._id) {
            this.hatchPopup = false;
          }
        }
      });

      this.$events.listen("staff-battery-decision", (deliverer) => {
        if (this.deliverer !== null) {
          if(deliverer._id === this.deliverer._id) {
            this.batteryPopup = false;
            this.deliverer = null;
          }
        }
      });

      this.$events.listen("battery-change-request", (deliverer) => {
        this.batteryPopup = true;
        this.deliverer = deliverer;
      });
    },
  };
</script>
<style>
  .request-button-row {
    margin-top: 40px;
  }
  .wrapper {
    text-align: center;
    margin: 0 auto;
  }

</style>
